<script setup lang="ts">
  withDefaults(
    defineProps<{
      isFullPage?: boolean
      size?: 'small' | 'regular' | 'x-small'
      speed?: 'normal' | 'fast'
    }>(),
    {
      isFullPage: false,
      size: 'regular',
      speed: 'normal',
    },
  )
</script>

<template>
  <div
    class="flex items-center justify-center loading w-full h-full"
    :class="{
      'bg-white fixed inset-0 z-[9999]': isFullPage,
    }"
  >
    <div
      class="w-12 h-12 border-[5px] border-t-[5px] rounded-[50%] border-[#d1d5db] box-content border-e-[#38b769]"
      :class="{
        'w-6 h-6 ': size === 'small',
        'w-12 h-12 ': size === 'regular',
        'w-4 h-4 border-[3px] border-t-[3px]': size === 'x-small',
        'animate-spin-slow': speed === 'normal',
        'animate-spin': speed === 'fast',
      }"
    />
  </div>
</template>

<style scoped></style>
